import React, { useState, Component } from "react";
import styled from "styled-components";
const CodeInputCell = styled.div`
  ${props => props.theme.fonts.default};
  border: ${props => props.theme.borders.input};
  border-radius: 4px;
  background-color: ${props => props.theme.colors.white};
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-family: "Work Sans", sans-serif;
  font-weight: 700;
  position: relative;
  margin-right: 10px;

  ${props => props.error && `border-color: ${props.theme.colors.inputErrorBorder};
    border-width: 2px;
    background-color: ${props.theme.colors.inputErrorBg}`};

  ${props => (props.selected || props.filled) && props.focused && `border-color: ${props.theme.colors.action};
    box-shadow: 0 0 4px 0 ${props.theme.colors.action};`}
`;
const CodeInput = styled.input`
  width: 32px;
  top: 0px;
  bottom: 0px;
  position: absolute;
  border: none;
  font-size: 22px;
  text-align: center;
  background-color: transparent;
  outline: none;
  left: ${props => props.leftPosition};
  opacity: ${props => props.opacity};
  z-index: 1;
`;
const CodeInputContainer = styled.div`
  position: relative;
  display: flex;
`;
const CODE_LENGTH = new Array(6).fill(0);
export const VerifyCode = ({
  onChange,
  size,
  error,
  ...props
}) => {
  const CODE_LENGTH = new Array(size).fill(0);
  const input = React.createRef();
  const [value, setValue] = useState("");
  const [focused, setFocused] = useState(false);

  const handleClick = () => {
    input.current.focus();
  };

  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  const handleKeyUp = e => {
    if (e.key === "Backspace") {
      setValue(value.slice(0, value.length - 1));
    }
  };

  const handleChange = e => {
    const newValue = e.target.value;
    const updatedValue = value && value.length >= CODE_LENGTH.length ? value : (value + newValue).slice(0, CODE_LENGTH.length);
    onChange(updatedValue);
    setValue(updatedValue);
  };

  const values = value ? value.split("") : [];
  const selectedIndex = values.length < CODE_LENGTH.length ? values.length : CODE_LENGTH.length - 1;
  const hideInput = !(values.length < CODE_LENGTH.length);
  return React.createElement(CodeInputContainer, {
    onClick: handleClick
  }, React.createElement(CodeInput, {
    value: "",
    ref: input,
    onChange: handleChange,
    onKeyUp: handleKeyUp,
    onFocus: handleFocus,
    onBlur: handleBlur,
    leftPosition: `${selectedIndex * (40 + 10)}px`,
    opacity: hideInput ? 0 : 1,
    type: "tel"
  }), CODE_LENGTH.map((v, index) => {
    const selected = values.length === index;
    const filled = values.length === CODE_LENGTH.length && index === CODE_LENGTH.length - 1;
    return React.createElement(CodeInputCell, {
      selected: selected,
      filled: filled,
      focused: focused,
      error: error
    }, values[index]);
  }));
};